export const GoldStars = ({ size = 16, gap = 2, className = "", color = "#D4AF37", count = 5 }) => (
  <span className={`inline-flex items-center ${className}`} style={{ gap }} aria-label={`${count} stelle`} data-testid="gold-stars">
    {[...Array(count)].map((_, i) => (
      <svg key={i} width={size} height={size} viewBox="0 0 24 24" shapeRendering="geometricPrecision" aria-hidden="true">
        <path d="M12 2.6l2.93 6.2 6.8.8-5.03 4.68 1.34 6.72L12 17.62 5.96 21l1.34-6.72L2.27 9.6l6.8-.8z" fill={color} />
      </svg>
    ))}
  </span>
);
